import React from 'react'
import { IProcessList } from '@shared/components/sections/process/data'
import styled from 'styled-components'

export const Point = ({ point, idx }: { point: IProcessList; idx: number }) => {
	return (
		<ItemRoot>
			<CellNumber>{idx + 1}</CellNumber>
			<CellTitle>{point.title}</CellTitle>
			<CellText>{point.text}</CellText>
		</ItemRoot>
	)
}

const ItemRoot = styled.li(({ theme }) => ({
	display: 'grid',
	gap: 10,
	marginBottom: 20,
	gridTemplateColumns: 'min-content auto',
	gridTemplateAreas: '"number title" "text text"',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		gridTemplateAreas: '"number title" "number text"',
	},
}))

const CellNumber = styled.span(({ theme }) => ({
	gridArea: 'number',
	width: 48,
	height: 48,
	borderRadius: '50%',
	border: '2px solid black',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	...theme.typography.header20_24,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header24_32,
		width: 56,
		height: 56,
	},
	[theme.mediaQueries.mediaMinWidthTablet]: {
		width: 40,
		height: 40,
	},
}))

const CellTitle = styled.h4(({ theme }) => ({
	gridArea: 'title',
	alignSelf: 'center',
	...theme.typography.header18_24,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header24_32,
		alignSelf: 'flex-start',
	},
}))

const CellText = styled.p(({ theme }) => ({
	gridArea: 'text',
	opacity: 0.5,
	...theme.typography.text16_22,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text18_24,
	},
}))
